// System alerts
const FLASH_NOTIFICATION_ADD = "FLASH::ADD_NOTIFICATION";
const FLASH_NOTIFICATION_REMOVE = "FLASH::REMOVE_NOTIFICATION";

export { FLASH_NOTIFICATION_ADD, FLASH_NOTIFICATION_REMOVE };
